import moment from 'moment'
import * as types from '../mutation-types'
import C from '../../constants'

// State for the report license expiry components
// keep separate state for the date range because this date range will be larger than the site date range
const state = {
  dateRange: [ moment().subtract(90, 'days').format(C.M_FMT_MS), moment().format(C.M_FMT_MS) ],
  expiresInDays: 14,
  expiresAgoDays: 30
}

const getters = {
  reportLicenseExpiryDateRange: state => state.dateRange,
  expiresInDays: state => state.expiresInDays,
  expiresAgoDays: state => state.expiresAgoDays
}

const actions = {
}

const mutations = {
  [types.FILTER_REPORT_LICENSE_EXPIRY_DATE_RANGE] (state, dateRange) {
    state.dateRange = dateRange
  },
  [types.FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_IN_DAYS] (state, expiresInDays) {
    state.expiresInDays = expiresInDays
  },
  [types.FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_AGO_DAYS] (state, expiresAgoDays) {
    state.expiresAgoDays = expiresAgoDays
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filterReportLicenseExpiry.js